import { z } from "zod";

export const ConnectionRequestType = {
  INTRO: "intro",
} as const;

export const ConnectionRequestTypeSchema = z.enum(ConnectionRequestType);

export type ConnectionRequestType = z.infer<typeof ConnectionRequestTypeSchema>;
